export default "__VITE_ASSET__DQy48aPr__"